import { render, staticRenderFns } from "./NovoFollowUpCartao.vue?vue&type=template&id=3dfefa35&scoped=true"
import script from "./NovoFollowUpCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./NovoFollowUpCartao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NovoFollowUpCartao.vue?vue&type=style&index=0&id=3dfefa35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfefa35",
  null
  
)

export default component.exports